/* eslint-disable max-len */
/* eslint-disable no-else-return */
/* eslint-disable array-callback-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-globals */

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const defaultType = dc.getType('default');
  const defaultView = defaultType.view;

  function handleButtonClickOpenReaderManager(model) {
    const {handleModalReaderManager} = opts;
    handleModalReaderManager(
      model,
    );
  }

  function buttonToHandleManager(model) {
    const traitCustomSumHandler = {
      name: 'buttonManageReader',
      type: 'button',
      text: 'Manejar Componente',
      full: true,
      command: () => handleButtonClickOpenReaderManager(
        model,
      ),
    };
    model.addTrait(traitCustomSumHandler);
  }

  dc.addType(opts.name, {
    model: {
      defaults: {
        traits: [],
      },
    },

    // eslint-disable-next-line consistent-return
    isComponent: (el) => {
      try {
        const attr = el.attributes;
        if (attr['data-gjs-sluglofty'] && attr['data-gjs-sluglofty'].value.includes('readerCoreContainer')) {
          return {
            type: opts.name,
          };
        }
      } catch (error) {
        // console.log(error);
      }
    },

    view: defaultView.extend({
      init({model}) {
        this.listenTo(model, '', this.restoreData());
      },
      restoreData() {
        if (this.model.attributes.sluglofty.includes('readerCoreContainer')) {
          this.model.removeTrait('buttonManageReader');
          buttonToHandleManager(this.model);
        }
      },
    }),
  });
};
